import type { AppStartListening } from "types/AppStartListening";
import { messagesActions } from "features/messages/store/slice";
import { DossierClientMethodNames } from "features/messages/hubs/sections/DossierSection";
import { MessageArgsToType } from "features/messages/helpers";
import { caseManagementActions } from "./slice";
import { DossierInformationChanged } from "features/cases/types/DossierInformationChanged";
import { DossierRemoved } from "features/cases/types/DossierRemoved";
import { PersistentRecordingTaskStatistics } from "types/PersistentRecordingTaskStatistics";
import { PersistedRecordingDownloadStatus } from "types/PersistedRecordingDownloadStatus";

// listeners
export const addCaseManagementListeners = (
    startListening: AppStartListening,
) => {
    startListening({
        predicate: (action) => {
            return (
                messagesActions.messageReceived.match(action) &&
                action.payload.messageType ===
                    DossierClientMethodNames.PersistentRecordingTaskStatistics_DownloadStatus
            );
        },
        effect: async (action, listenerApi) => {
            if (messagesActions.messageReceived.match(action)) {
                const dossierDownloadStatusStatistics = MessageArgsToType<
                    PersistentRecordingTaskStatistics<PersistedRecordingDownloadStatus>
                >(action.payload.args);

                listenerApi.dispatch(
                    caseManagementActions.updateDossierDownloadStatusStatistics(
                        { dossierDownloadStatusStatistics },
                    ),
                );
            }
        },
    });

    startListening({
        predicate: (action) => {
            return (
                messagesActions.messageReceived.match(action) &&
                action.payload.messageType ===
                    DossierClientMethodNames.DossierInformationChanged
            );
        },
        effect: async (action, listenerApi) => {
            if (messagesActions.messageReceived.match(action)) {
                const dossierInformationChanged =
                    MessageArgsToType<DossierInformationChanged>(
                        action.payload.args,
                    );

                listenerApi.dispatch(
                    caseManagementActions.updateDossierInformation({
                        dossierInformationChanged,
                    }),
                );
            }
        },
    });

    startListening({
        predicate: (action) => {
            return (
                messagesActions.messageReceived.match(action) &&
                action.payload.messageType ===
                    DossierClientMethodNames.DossierRemoved
            );
        },
        effect: async (action, listenerApi) => {
            if (messagesActions.messageReceived.match(action)) {
                const dossierRemoved = MessageArgsToType<DossierRemoved>(
                    action.payload.args,
                );

                listenerApi.dispatch(
                    caseManagementActions.removeDossier({ dossierRemoved }),
                );
            }
        },
    });
};
